const performanceTestIDs = {
  performanceScreen: 'performance-screen',
};

export default performanceTestIDs;
